import { IntlShape } from 'react-intl';

import messages from '@/components/emotion-detector/messages';

export function getSenderName(role: 'user' | 'assistant', formatMessage: IntlShape['formatMessage']): string {
	return role === 'user'
		? formatMessage(messages.cameraChatYou)
		: formatMessage(messages.cameraChatAssistant);
}
